import { render, staticRenderFns } from "./IconPackCards.vue?vue&type=template&id=6273901f"
import script from "./IconPackCards.vue?vue&type=script&lang=js"
export * from "./IconPackCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports